import { render, staticRenderFns } from "./PersonDetails.vue?vue&type=template&id=561e897e&scoped=true"
import script from "./PersonDetails.vue?vue&type=script&lang=js"
export * from "./PersonDetails.vue?vue&type=script&lang=js"
import style0 from "./PersonDetails.vue?vue&type=style&index=0&id=561e897e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561e897e",
  null
  
)

export default component.exports